/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const PEPREPRESENTATIVE_ADD = 'PEPREPRESENTATIVE_ADD';
export const PEPREPRESENTATIVE_BEGIN = 'PEPREPRESENTATIVE_BEGIN';
export const PEPREPRESENTATIVE_FAILURE = 'PEPREPRESENTATIVE_FAILURE';
export const PEPREPRESENTATIVE_CLEAR = 'PEPREPRESENTATIVE_CLEAR';

export const PEPREPRESENTATIVE_FILTER_BEGIN = 'PEPREPRESENTATIVE_FILTER_BEGIN';
export const PEPREPRESENTATIVE_FILTER_SUCCESS = 'PEPREPRESENTATIVE_FILTER_SUCCESS';
export const PEPREPRESENTATIVE_FILTER_FAILURE = 'PEPREPRESENTATIVE_FILTER_FAILURE';
export const PEPREPRESENTATIVE_FILTER_CLEAR = 'PEPREPRESENTATIVE_FILTER_CLEAR';

export function fetchPEPRepresentative(params = {}) {
	return async dispatch => {
        dispatch(pepRepresentativeBegin());
        await ApiService.getResponsible(params)
			.then(
            result => {
                    dispatch(pepRepresentativeAdd(result));
				},
				error => {
                    dispatch(pepRepresentativeError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchPEPRepresentativeFilter(params = {}) {
    return async dispatch => {
        await ApiService.getResponsibleFilter(params)
            .then(
                result => {
                    dispatch(pepRepresentativeFilterAdd(result));
                },
                error => {
                    dispatch(pepRepresentativeFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

//PEPRepresentative
export const pepRepresentativeBegin = () => ({
    type: PEPREPRESENTATIVE_BEGIN,
});

export const pepRepresentativeAdd = data => ({
    type: PEPREPRESENTATIVE_ADD,
	payload: { data }
})

export const pepRepresentativeError = () => ({
    type: PEPREPRESENTATIVE_FAILURE,
})

export const pepRepresentativeClear = () =>({
    type: PEPREPRESENTATIVE_CLEAR,
})

//PEPRepresentative Filters
export const pepRepresentativeFilterBegin = () => ({
    type: PEPREPRESENTATIVE_FILTER_BEGIN,
});
export const pepRepresentativeFilterAdd = filterData => ({
    type: PEPREPRESENTATIVE_FILTER_SUCCESS,
    payload: { filterData }
})
export const pepRepresentativeFilterError = filterError => ({
    type: PEPREPRESENTATIVE_FILTER_FAILURE,
    payload: { filterError }
})

export const pepRepresentativeClearFilter = () => ({
    type: PEPREPRESENTATIVE_FILTER_CLEAR,
})
